export const faqs = [
  {
    question: "What are credits and what can I do with credits?",
    answer: "Credits are a form of virtual tokens that you can purchase with real money and use to download worksheets."
  },
  {
    question: "How many credits for a single worksheet?",
    answer: "Each PDF download costs one credit, including repeated downloads or answer keys downloaded separately. Generating uses your daily AI allowance, not download credits. Editing and previewing are free."
  },
  {
    question: "Can I get a refund for unused credits?",
    answer: "We do not offer refunds on purchased credits, but you can use them anytime."
  },
  {
    question: "What payment methods can I use?",
    answer: "You can pay through Paypal or credit card. We accept credit or debit card from following: Visa, Mastercard, American Express, JCB, and More."
  },
];